<ul class="horizontal-list ">
  <li *ngIf="getmentItem(breadCrumbs)">
    <a href="javascript: void(0)" (click)="OnClickPath('Root')">Root</a>
  </li>
  <ng-container *ngFor="let crumb of breadCrumbs">
    <li *ngIf="crumb?.type == 'folder'">
      <a href="javascript: void(0)" (click)="OnClickPath(crumb)">{{crumb.name}}</a>
    </li>
  </ng-container>
</ul>